<div class="last-activity-container"
     [class]="getOnlineStatus()">
  <span class="material-symbols-rounded">circle</span>

  {{ lastActivity }}
</div>
